import { BrowserRouter, Routes, Route } from "react-router-dom";
import NoticePage from "./templates/menu/notice";
import LoginPage from "./templates/login";
import NoticeEditPage from "./templates/menu/noticeEdit";
import HistoryPage from "./templates/menu/history";
import HistoryDetailPage from "./templates/menu/historyDetail";
import NoticeDetailPage from "./templates/menu/noticeDeatail";
import PasswordChangePage from "./templates/passwordChange";

function App() {

  return (

      <BrowserRouter>

        <Routes>

          <Route path="/" element={<LoginPage />} />
          <Route path="/notice" element={<NoticePage />} />
          <Route path="/noticeEdit" element={<NoticeEditPage />} />
          <Route path="/history" element={<HistoryPage />} />
          <Route path="/historyDetail" element={<HistoryDetailPage />} />
          <Route path="/noticeDetail" element={<NoticeDetailPage />} />
          <Route path="/passwordChange" element={<PasswordChangePage />} />

        </Routes>

      </BrowserRouter>

  );

}

export default App;
